import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Spinner, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModalDownloadingDocument = ({ show, title, message, documentType }) => {
    // Determinar el ícono y color basado en el tipo de documento
    let icon = "file-alt";
    let iconColor = "text-primary";
    
    if (documentType === 'pdf') {
        icon = "file-pdf";
        iconColor = "text-danger";
    } else if (documentType === 'xml') {
        icon = "file-code";
        iconColor = "text-warning";
    }

    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            keyboard={false}
            size="sm"
            className="modal-downloading-document"
        >
            <Modal.Body className="text-center p-4">
                {/* Spinner animado */}
                <div className="mb-3 position-relative d-inline-block">
                    <Spinner
                        animation="border"
                        variant="primary"
                        style={{ width: '4rem', height: '4rem' }}
                    />
                    <div 
                        className="position-absolute top-50 start-50 translate-middle"
                        style={{ fontSize: '1.5rem' }}
                    >
                        <FontAwesomeIcon 
                            icon={icon} 
                            className={iconColor}
                            beat
                        />
                    </div>
                </div>

                {/* Título */}
                <h5 className="mb-2 fw-bold text-primary">
                    {title || 'Descargando Documento'}
                </h5>

                {/* Mensaje */}
                <p className="text-muted mb-3 small">
                    {message || 'Por favor espere mientras se procesa la descarga...'}
                </p>

                {/* Barra de progreso indeterminada */}
                <ProgressBar 
                    animated 
                    now={100} 
                    variant="primary"
                    style={{ height: '4px' }}
                />

                {/* Nota adicional */}
                <p className="text-muted mt-3 mb-0 small">
                    <FontAwesomeIcon icon="circle-info" className="me-1" />
                    No cierre esta ventana
                </p>
            </Modal.Body>

            {/* Estilos inline para animaciones adicionales */}
            <style jsx="true">{`
                .modal-downloading-document .modal-content {
                    border-radius: 12px;
                    border: none;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
                }
                
                .modal-downloading-document .modal-body {
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                }

                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.6;
                    }
                }
            `}</style>
        </Modal>
    );
};

ModalDownloadingDocument.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    documentType: PropTypes.oneOf(['pdf', 'xml', 'generic'])
};

ModalDownloadingDocument.defaultProps = {
    documentType: 'generic'
};

export default ModalDownloadingDocument;
